import { DashboardWidgetWidth } from '@/components/dashboard/model';
import { DashboardDateScopeMode } from '../../../dashboard/model';
import {
  integrationDashboardDocumentSchema,
  IntegrationDashboardMetric,
  IntegrationDashboardWidgetType,
} from './widgetModel';

const inherit = { mode: DashboardDateScopeMode.Inherit } as const;
const metricOrder = [
  IntegrationDashboardMetric.BidRequests,
  IntegrationDashboardMetric.BidResponses,
  IntegrationDashboardMetric.WonBids,
  IntegrationDashboardMetric.FilledImpressions,
  IntegrationDashboardMetric.AdImpressions,
  IntegrationDashboardMetric.Revenue,
] as const;

export const defaultIntegrationDashboardDocument = integrationDashboardDocumentSchema.parse({
  version: 1,
  widgets: [
    ...metricOrder.map((metric) => ({
      id: `integration-${metric.toLowerCase().replaceAll('_', '-')}`,
      type: IntegrationDashboardWidgetType.Metric,
      width: DashboardWidgetWidth.Sixth,
      dateScope: inherit,
      metric,
    })),
    ...[
      IntegrationDashboardMetric.Profit,
      IntegrationDashboardMetric.Margin,
      IntegrationDashboardMetric.Ecpm,
      IntegrationDashboardMetric.Srpm,
    ].map((metric) => ({
      id: `integration-${metric.toLowerCase()}`,
      type: IntegrationDashboardWidgetType.Metric,
      width: DashboardWidgetWidth.Quarter,
      dateScope: inherit,
      metric,
    })),
    {
      id: 'integration-performance',
      type: IntegrationDashboardWidgetType.PerformanceChart,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      metrics: [...metricOrder, IntegrationDashboardMetric.Ecpm],
    },
  ],
});
